import React, { useState, useCallback, useEffect, useRef } from "react";
import ContentWrapper from "../../../../components/common/ContentWrapper";
import Card from "../../../../components/common/Card";
import CardHeader from "../../../../components/common/CardHeader";
import CardBody from "../../../../components/common/CardBody";
import CardTitle from "../../../../components/common/AssessmentCardTitle";
import ChevronLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ChevronRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import PaperFilterLayout from "../../paper/edsider/TheFilter/PaperFilterLayout";
import { EMPLOYEE_FILTERS } from "../../../../helper/constants";
import StickyCardBody from "../../../../components/common/StickyCardBody";
import TabList from "../../../../components/common/tabs/TabList";
import NavItem from "../../../../components/common/tabs/NavItem";
import ReactForm from "react-bootstrap/Form";
import TabContent from "../../../../components/common/tabs/TabContent";
import TabPane from "../../../../components/common/tabs/TabPane";
import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  IconButton,
} from "@mui/material";
import ReactSpinner from "react-bootstrap/Spinner";
import MaterialCustomTablePagination from "../../../../components/common/MaterialCustomTablePagination";
import { studentUserActions } from "../../../../actions/user_management/studentUserActions";
import { useDispatch } from "react-redux";
import { debounce } from "lodash";
import { Form, Row, Col, Spinner, Button, Image } from "react-bootstrap";

import Modal from "react-bootstrap/Modal";
import { assessmentService } from "../../../../service/assessment/assessmentService";
import './userReports.css'



function UserReports() {
  const dispatch = useDispatch();

  const [assMetaData, setAssmentMetaData] = useState({
    allCategories: [],
    allLanguages: [],
    allSubjects: [],
    allYears: [],
    allDifficulties: [],
    allGrades: [],
    allTerms: [],
    allChapters: [],
    allCurrencyTypes: []
  })

  const [state, setState] = useState({
    offset: 0,
    rowsPerPage: 10,
    sort_column: "last_seen",
    sort_direction: "desc",
    search_term: "",
    selectedGrades: [],
    selectedLanguages: [],
    selectedStartDate: null,
    selectedEndDate: null,
    selectedExamCategories: [],
    selectedChapters: [],
    selectedDifficulties: [],
    selectedTerms: [],
    selectedYears: [],
    selectedSubjects: [],
    selectedStatuses: [],
    selectedExamCategories: [],
    is_signin_dates_select: "true",
    currentPage: 0,
  });
  const [studentPaperEnrolment, setStudentPaperEnrolment] = useState({
    assessments: [],
    totalAssessmentCount: 0
  });
  const [studentsDetails, setStudentsDetails] = useState({
    students: [],
    totalStudentCount: 0,
  });

  const [paperEnrolStatusCounts, setPaperEnrolStatusCounts] = useState({
    papers: [],
    totalPaperCount: 0,
  });
  const [paperDetails, setPaperDetails] = useState({
    paper_details: []
  })
  const [assStudentDetails,setAssStudentDetails]= useState({
    students:[]
  })

  const [isFilterCollapsed, setIsFilterCollapsed] = useState(false);
  const [isTableDataLoading, setIsTableDataLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("Sign-in Details");
  const [searchQuery, setSearchQuery] = useState("");
  const mountedRef = useRef(true);

  const [assessmentModalShow, setAssessmentModelShow] = useState(false);
  const [studentModelShow,setStudentModelShow]=useState(false);
  const [modelDataLoding,setModelDataLoding]= useState(false)


  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      is_signin_dates_select: activeTab === "Sign-in Details" ? "true" : "false",
      offset: 0,
      currentPage: 0,
    }));
  }, [activeTab]);

  useEffect(() => {
    let cancelled = false;
    const fetchStudents = async () => {
      setIsTableDataLoading(true);
      try {
        if (activeTab === "Student Enroll Details") {

          const assessmentMetaDataResponse = await assessmentService.getAllAssessmentMetaData();
          if (assessmentMetaDataResponse.success) {
            setAssmentMetaData((pre) => ({
              ...pre,
              allCategories: assessmentMetaDataResponse.data.find(item => 'categories' in item)?.categories || [],
              allLanguages: assessmentMetaDataResponse.data.find(item => 'languages' in item)?.languages || [],
              allSubjects: assessmentMetaDataResponse.data.find(item => 'subjects' in item)?.subjects || [],
              allYears: assessmentMetaDataResponse.data.find(item => 'years' in item)?.years || [],
              allDifficulties: assessmentMetaDataResponse.data.find(item => 'difficulty_types' in item)?.difficulty_types || [],
              allGrades: assessmentMetaDataResponse.data.find(item => 'grades' in item)?.grades || [],
              allTerms: assessmentMetaDataResponse.data.find(item => 'terms' in item)?.terms || [],
              allChapters: assessmentMetaDataResponse.data.find(item => 'chapters' in item)?.chapters || [],
              allCurrencyTypes: assessmentMetaDataResponse.data.find(item => 'currency_types' in item)?.currency_types || [],
            }));
          }

          const res = await dispatch(studentUserActions.get_student_paper_enrol_status_counts(state));
          const papers = res?.students ?? [];
          if (cancelled || !mountedRef.current) return;
          setPaperEnrolStatusCounts({
            papers,
            totalPaperCount: res?.count ?? 0,
          });

        } else if (activeTab === "Paper Enroll Details") {
          const result = await dispatch(studentUserActions.get_paper_enroled_student_counts(state));
          if (cancelled || !mountedRef.current) return;
          const assessments = result?.assessments;
          

          const totalAssessmentCount = result?.total_count || 0;
          if (cancelled || !mountedRef.current) return;
          setStudentPaperEnrolment({
            assessments:assessments,
            totalAssessmentCount:totalAssessmentCount
          });
        } else {
          const res = await dispatch(studentUserActions.getAllStudents(state));
          const students = res?.students ?? [];
          if (cancelled || !mountedRef.current) return;
          setStudentsDetails({
            students,
            totalStudentCount: res?.count ?? 0,
          });
        }
      } catch (err) {
        console.error("Error fetching student(s):", err);
      } finally {
        if (!cancelled && mountedRef.current) setIsTableDataLoading(false);
      }
    };

    fetchStudents();

    return () => {
      cancelled = true;
    };
  }, [state, activeTab, dispatch]);

  const handlePageChange = useCallback((event, newPage) => {
    setState((prevState) => {
      const newOffset = newPage * prevState.rowsPerPage;
      return {
        ...prevState,
        currentPage: newPage,
        offset: newOffset,
      };
    });
  }, []);

  const handleRowsPerPageChange = useCallback((event) => {
    const newLimit = parseInt(event.target.value, 10) || 10;
    setState((prevState) => ({
      ...prevState,
      rowsPerPage: newLimit,
      currentPage: 0,
      offset: 0,
    }));
  }, []);

  const handlePageOffsetChange = useCallback((newOffset, newPage) => {
    setState((prevState) => ({
      ...prevState,
      offset: newOffset,
      currentPage: newPage,
    }));
  }, []);

  const handleFilterChange = (newSelectedFilters) => {
    const getOrNull = (key) =>
      newSelectedFilters?.[key] && newSelectedFilters[key].length > 0
        ? newSelectedFilters[key]
        : null;

    setState((prev) => ({
      ...prev,
      selectedGrades: getOrNull("Grade"),
      selectedsubjects: getOrNull("Subject"),
      selectedCategories: getOrNull("Category"),
      selectedAuthors: getOrNull("Author"),
      selectedChapters: getOrNull("Chapter"),
      selectedDifficulties: getOrNull("Difficulty"),
      selectedLanguages: getOrNull("Language"),
      selectedYears: getOrNull("Year"),
      selectedTerms: getOrNull("Term"),
      selectedStatuses: getOrNull("Status"),
      selectedReviewers: getOrNull("Reviewers"),
      selectedExamCategories: getOrNull("Exam_Category"),
      selectedStartDate: getOrNull("StartDate"),
      selectedEndDate: getOrNull("EndDate"),
      selectedYears: getOrNull("Year"),
      offset: 0,
      currentPage: 0,
    }));
  };

  const debouncedUpdateStateSearch = useRef(
    debounce((searchTerm) => {
      setState((prevState) => {
        const safeLimit = prevState.rowsPerPage || 10;
        return {
          ...prevState,
          search_term: searchTerm,
          offset: 0,
          currentPage: 0,
          rowsPerPage: safeLimit,
        };
      });
    }, 300)
  ).current;

  useEffect(() => {
    return () => {
      debouncedUpdateStateSearch.cancel();
    };
  }, [debouncedUpdateStateSearch]);

  const handleSearchInputChange = (e) => {
    const value = (e?.target?.value ?? "").toString();
    setSearchQuery(value);

    const trimmed = value.trim();
    const regex = /^[\p{L}\p{M}\p{N}\p{P}\p{S}\s]*$/u;

    if (trimmed === "" || regex.test(trimmed)) {
      debouncedUpdateStateSearch(trimmed);
    } else {
      setState((prevState) => ({
        ...prevState,
        search_term: trimmed,
      }));
    }
  };


  const filteredStudents = (studentsDetails.students || []).filter((stu) => {
    const queryWords = searchQuery.toLowerCase().trim().split(" ");
    const fullName = `${stu.first_name ?? ""} ${stu.last_name ?? ""}`.toLowerCase();

    return queryWords.every((word) =>
      fullName.includes(word) ||
      (stu.stu_id ?? "").toString().toLowerCase().includes(word) ||
      (stu.user_code ?? "").toString().toLowerCase().includes(word)
    );
  });


  const filteredPapers = (paperEnrolStatusCounts.papers || []).filter((paper) => {
    const queryWords = searchQuery.toLowerCase().trim().split(" ");
    const fullName = `${paper.first_name ?? ""} ${paper.last_name ?? ""}`.toLowerCase();

    return queryWords.every((word) =>
      fullName.includes(word) ||
      (paper.stu_id ?? "").toString().toLowerCase().includes(word) ||
      (paper.user_code ?? "").toString().toLowerCase().includes(word)
    );
  });

  const filteredStudentEnrolments = (studentPaperEnrolment.assessments || []).filter((assessment) => {
    const queryWords = searchQuery.toLowerCase().trim().split(" ");
    const assessName = (assessment.assess_name || "").toLowerCase();
     const assessmentName = (assessment.assessment_name || "").toLowerCase();
   const assessmentIdStr = (assessment.assessment_id || "").toString().toLowerCase();
  const assessmentIdPattern = `asmnt${assessmentIdStr}`;
    return queryWords.every((word) =>
      assessName.includes(word) || assessmentIdPattern.includes(word) || assessmentName.includes(word)
    );
  });
  const toggleFilter = useCallback(() => {
    setIsFilterCollapsed((prev) => !prev);
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const d = new Date(dateString);

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");

    return `${year}/${month}/${day}`;
  };


  const formatTime = (dateString) => {
    if (!dateString) return "";
    const d = new Date(dateString);
    return d.toLocaleTimeString("en-US");
  };
  const formatTimeForSignUp = (dateString) => {
    if (!dateString) return "";

    // Convert "2025-08-15 11:55:15.414066" → "2025-08-15T11:55:15.414066Z"
    const isoString = dateString.replace(" ", "T") + "Z";

    const d = new Date(isoString);

    return new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
      timeZone: "Asia/Colombo",
    }).format(d);
  };


  const viewStudentAssessmentDetail = async (studentId) => {
    try {
      setAssessmentModelShow(true);//model open------------------->popup page
      setModelDataLoding(true);
      const res = await dispatch(studentUserActions.get_student_paper_details(studentId));
      setPaperDetails({ paper_details: res?.assessments || [] });


    } catch (err) {
      console.error("Failed to fetch paper details:", err);
    }finally{
      setModelDataLoding(false);
    }
  };

  const viewAssessmentStudentDetail = async (assessmentId) => {
    try {
      setStudentModelShow(true);//model open------------------->popup page
      setModelDataLoding(true);
      const res = await dispatch(studentUserActions.get_assessment_student_details(assessmentId));
      setAssStudentDetails({ students: res?.students || [] });


    } catch (err) {
      console.error("Failed to fetch student details:", err);
    }finally{
      setModelDataLoding(false);
    }
  };

  const UserOwnPaper = () => {
    const [expandedItem, setExpandedItem] = useState(null);

    const toggleExpand = (idx) => {
      setExpandedItem(prev => (prev === idx ? null : idx));
    };

    const statusDisplayName = {
        assigned: "Not Started",
        assign: "Not Started",        
        pending: "Pending",
        inprogress: "In Progress",
        completed: "Completed",
        rejected: "Rejected",
  
      };
     const papers = paperDetails?.paper_details || [];
    if (papers.length === 0) {
      return <p className="text-muted">No assessments enrolled.</p>;
    }

    return (
      <div className="cart-scroll-box" style={{ maxHeight: "60vh", overflowY: "auto" }}>

        {papers.map((p, idx) => {
          const assessment_id = p.assessment_id;
          const examTitle = p.assess_name || "Untitled ";
          const candidate_status = p.candidate_status || "N/A"
          const subject = assMetaData.allSubjects.find(s => s.subject_id == p.subject_id)?.subject || "N/A";
          const grade = assMetaData.allGrades.find(g => g.grade_id == p.grade_id)?.grade || "N/A";
          const language = assMetaData.allLanguages.find(l => l.language_id == p.language_id)?.language || "N/A";
          const difficulty = assMetaData.allDifficulties.find(d => d.difficulty_id == p.difficulty_id)?.difficulty_type || "N/A";
          const category = assMetaData.allCategories.find(a => a.category_id == p.exam_category_id)?.name || "N/A";
          const amount = p.amount || "Free";
          const enrolled_date = new Date(p.enrolled_time).toISOString().split("T")[0];
          const no_of_credits = p.no_of_credits || "-";

          return (
            <Row key={p.assessment_id || idx} className="paper-row">
              <label className="paper-label">
                {/* Hidden checkbox controls dropdown */}
                <input
                  type="checkbox"
                  checked={expandedItem === idx}
                  onChange={() => toggleExpand(idx)}
                  className="paper-checkbox"
                />

                {/* Row header */}
                <div className="paper-title">
                  <div className="exam-title">{examTitle}</div>
                  

                  <div className={`candidate-status ${candidate_status?.toLowerCase()}`}>
                    {statusDisplayName[candidate_status?.toLowerCase()] || candidate_status}
                  </div>

                  <div className={`arrow ${expandedItem === idx ? "open" : ""}`}>▼</div>
                </div>


                {/* Dropdown content */}
                <div className={`paper-details ${expandedItem === idx ? "open" : ""}`}>
                  <div><strong>Assessment Id:</strong>{"ASMNT"}{assessment_id}</div>
                  {amount>0 &&<div><strong>amount:</strong> {" "}{amount}{".00"}</div>}
                  {no_of_credits>0 &&<div><strong>No of credit :</strong>{no_of_credits}</div>}
                  <div><strong>Subject:</strong> {subject}</div>
                  <div><strong>Grade:</strong> {grade}</div>
                  <div><strong>Language:</strong> {language}</div>
                  <div><strong>Enrolled Date:</strong>{enrolled_date}</div>
                  {difficulty && <div><strong>Difficulty:</strong> {difficulty}</div>}
                  {category && <div><strong>Category:</strong> {category}</div>}
                  {p.score != null && <div><strong>Score:</strong> {p.score}</div>}
                  {p.attempted_at && <div><strong>Attempted On:</strong> {formatDate(p.attempted_at)}</div>}
                </div>
              </label>
            </Row>


          );
        })}
      </div>
    );
  };

  const AssessmentOwnStudents = () => {
    const [expandedItem, setExpandedItem] = useState(null);

    const toggleExpand = (idx) => {
      setExpandedItem(prev => (prev === idx ? null : idx));
    };

    const statusDisplayName = {
        assigned: "Not Started",
        assign: "Not Started",        
        pending: "Pending",
        inprogress: "In Progress",
        completed: "Completed",
        rejected: "Rejected",
  
      };

    const getGenderLabel = (genderId) => {
    if (!genderId) return "-";
    return genderId == 1 ? "Male" : genderId === 2 ? "Female" : "-";
  };

     const students = assStudentDetails?.students || [];
     
    if (students.length === 0) {
      return <p className="text-muted">No student enrolled.</p>;
    }

    return (
      <div className="cart-scroll-box" style={{ maxHeight: "60vh", overflowY: "auto" }}>

        {students.map((s, idx) => {
          const user_code = s.user_code;
          const first_name = s.first_name || " - ";
          const last_name = s.last_name || "-";
          const grade = assMetaData.allGrades.find(g => g.grade_id == s.grade)?.grade || "-";
          const email = s.email|| "-";
          const gender_id = s.gender_id||"-";
          const phone_numbe = s.phone_number||"-";
          const school = s.school||"-";
          const candidate_status=s.candidate_status;
          const enrolled_date = formatDate(s.enrolled_time);
           const last_login = formatDate(s.last_seen);

          return (
            <Row key={s.student_id || idx} className="paper-row">
              <label className="paper-label">
                {/* Hidden checkbox controls dropdown */}
                <input
                  type="checkbox"
                  checked={expandedItem === idx}
                  onChange={() => toggleExpand(idx)}
                  className="paper-checkbox"
                />

                {/* Row header */}
                <div className="paper-title">
                  <div className="user-code">{user_code}</div>
                  <div className="exam-title">{first_name}{" "}{last_name}</div>

                  <div className={`candidate-status ${candidate_status?.toLowerCase()}`}>
                    {statusDisplayName[candidate_status?.toLowerCase()] || candidate_status}
                  </div>

                  <div className={`arrow ${expandedItem === idx ? "open" : ""}`}>▼</div>
                </div>


                {/* Dropdown content */}
                <div className={`paper-details ${expandedItem === idx ? "open" : ""}`}>
                  <div><strong>Email: </strong>{email}</div>
                  <div><strong>Grade: </strong>{grade}</div>
                  <div><strong>Phone Numbe: </strong>{phone_numbe}</div>
                  <div><strong>Gender: </strong> {getGenderLabel(gender_id)}</div>
                  <div><strong>School: </strong>{school}</div>
                  <div><strong>Enrolled Date: </strong>{enrolled_date}</div>
                  <div><strong>Last Login: </strong>{last_login}</div>
                </div>
              </label>
            </Row>


          );
        })}
      </div>

    );
  };


  return (
    <div style={{ height: "90vh", overflow: "auto" }}>
      <ContentWrapper>
        <Card>
          <CardHeader>
            <CardTitle cardLabel="Student Report" />
          </CardHeader>

          <CardBody>
            <div className="thepapers-wrapper">
              <div className="col-md-12 px-0">
                <div className="row mt-6">
                  <div
                    className={`${isFilterCollapsed ? "col-md-1" : "col-md-3"
                      } px-0 transition-width`}
                  >
                    <div className="filter-container">
                      <div
                        className={`${isFilterCollapsed ? "collapsed-filter" : "expanded-filter"
                          } filter-dynamic`}
                      >
                        <div className="d-flex flex-column flex-md-row flex-wrap align-items-stretch align-items-md-center justify-content-between w-100 gap-2">
                          <span
                            className={`${isFilterCollapsed ? "d-block" : "d-none"
                              } filter-title`}
                          >
                            Filters
                          </span>
                          <IconButton onClick={toggleFilter} size="small">
                            {isFilterCollapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                          </IconButton>
                        </div>
                      </div>

                      {!isFilterCollapsed && activeTab !== "Paper Enroll Details" && (
                        <PaperFilterLayout
                          userType={"DEOP"}
                          onFilterChange={handleFilterChange}
                          filterKeys={EMPLOYEE_FILTERS.UserReports}
                          isShowExamStatus={false}
                        />
                      )}
                      {!isFilterCollapsed && activeTab === "Paper Enroll Details" && (
                        <PaperFilterLayout
                          userType={"DEOP"}
                          onFilterChange={handleFilterChange}
                          filterKeys={EMPLOYEE_FILTERS.studentEnrolDetails}
                          isShowExamStatus={false}
                        />
                      )}
                    </div>
                  </div>

                  <div className={isFilterCollapsed ? "col-md-11" : "col-md-9"}>
                    <div style={{ padding: 12 }}>
                      <StickyCardBody>
                        <div className="row align-items-center mt-5 justify-content-between">
                          <div className="col-md-8">
                            <TabList>
                              <NavItem
                                className={`nav-link ${activeTab === "Sign-in Details" ? "active" : ""}`}
                                id="manage-tab-1"
                                href="#manage-1"
                                dataToggle="tab"
                                iconName="flaticon2-chat-1"
                                tabName="Sign-in Details"
                                onClick={() => setActiveTab("Sign-in Details")}
                              />
                              <NavItem
                                className={`nav-link ${activeTab === "Sign-up Details" ? "active" : ""}`}
                                id="manage-tab-2"
                                href="#manage-2"
                                dataToggle="tab"
                                iconName="flaticon2-chat-1"
                                tabName="Sign-up Details"
                                onClick={() => setActiveTab("Sign-up Details")}
                              />
                              <NavItem
                                className={`nav-link ${activeTab === "Student Enroll Details" ? "active" : ""}`}
                                id="manage-tab-3"
                                href="#manage-3"
                                dataToggle="tab"
                                iconName="flaticon2-chat-1"
                                tabName="Student Enroll Details"
                                onClick={() => setActiveTab("Student Enroll Details")}
                              />
                              <NavItem
                                className={`nav-link ${activeTab === "Paper Enroll Details" ? "active" : ""}`}
                                id="manage-tab-4"
                                href="#manage-4"
                                dataToggle="tab"
                                iconName="flaticon2-chat-1"
                                tabName="Paper Enroll Details"
                                onClick={() => setActiveTab("Paper Enroll Details")}
                              />
                            </TabList>
                          </div>
                          <div className="col-md-4 ms-auto">
                            <ReactForm.Group controlId="searchInput" className="mb-2">
                              <ReactForm.Control
                                type="text"
                                placeholder="Search"
                                value={searchQuery}
                                onChange={handleSearchInputChange}
                              />
                            </ReactForm.Group>
                          </div>
                        </div>
                      </StickyCardBody>

                      <TabContent>
                        {/*-----------------------------------------------Sign-in Details------------------------------------------------- */}
                        {activeTab === "Sign-in Details" && (
                          <TabPane className="tab-pane fade show active" id="manage-1" ariaLabelledby="manage-tab-1">
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Student ID</TableCell>
                                  <TableCell>Student Name</TableCell>
                                  <TableCell>Login At</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {isTableDataLoading ? (
                                  <TableRow>
                                    <TableCell colSpan={5} align="center">
                                      <ReactSpinner animation="border" />
                                    </TableCell>
                                  </TableRow>
                                ) : filteredStudents.length > 0 ? (
                                  filteredStudents.map((stu) => (
                                    <TableRow key={stu.stu_id ?? stu.user_code}>
                                      <TableCell>{stu.user_code ?? stu.stu_id}</TableCell>
                                      <TableCell>{`${stu.first_name ?? ""} ${stu.last_name ?? ""}`.trim()}</TableCell>
                                      <TableCell>{formatDate(stu.last_seen)} {" "}
                                        <span style={{ color: "blue" }}>{formatTime(stu.last_seen)}</span>
                                      </TableCell>
                                    </TableRow>
                                  ))
                                ) : (
                                  <TableRow>
                                    <TableCell colSpan={5} align="center">
                                      No data found
                                    </TableCell>
                                  </TableRow>
                                )}
                              </TableBody>
                            </Table>

                            <div className="d-flex justify-content-end mt-3">
                              <MaterialCustomTablePagination
                                totalCount={studentsDetails.totalStudentCount}
                                currentPage={state.currentPage}
                                limit={state.rowsPerPage}
                                handlePageChange={handlePageChange}
                                handleRowsPerPageChange={handleRowsPerPageChange}
                                handlePageOffsetChange={handlePageOffsetChange}
                                offset={state.offset}
                                rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 75, 100, 150, 200, 250, 300]}
                              />
                            </div>
                          </TabPane>
                        )}
                        {/*-----------------------------------------------Sign-up Details------------------------------------------------- */}
                        {activeTab === "Sign-up Details" && (
                          <TabPane className="tab-pane fade show active" id="manage-2" ariaLabelledby="manage-tab-2">
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Student ID</TableCell>
                                  <TableCell>Student Name</TableCell>
                                  <TableCell>Join At</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {isTableDataLoading ? (
                                  <TableRow>
                                    <TableCell colSpan={5} align="center">
                                      <ReactSpinner animation="border" />
                                    </TableCell>
                                  </TableRow>
                                ) : filteredStudents.length > 0 ? (
                                  filteredStudents.map((stu) => (
                                    <TableRow key={stu.stu_id ?? stu.user_code}>
                                      <TableCell>{stu.user_code ?? stu.stu_id}</TableCell>
                                      <TableCell>{`${stu.first_name ?? ""} ${stu.last_name ?? ""}`.trim()}</TableCell>
                                      <TableCell>{formatDate(stu.created_at)} {" "}
                                        <span style={{ color: "blue" }}>{formatTimeForSignUp(stu.created_at)}</span>
                                      </TableCell>
                                    </TableRow>
                                  ))
                                ) : (
                                  <TableRow>
                                    <TableCell colSpan={5} align="center">
                                      No data found
                                    </TableCell>
                                  </TableRow>
                                )}
                              </TableBody>
                            </Table>

                            <div className="d-flex justify-content-end mt-3">
                              <MaterialCustomTablePagination
                                totalCount={studentsDetails.totalStudentCount}
                                currentPage={state.currentPage}
                                limit={state.rowsPerPage}
                                handlePageChange={handlePageChange}
                                handleRowsPerPageChange={handleRowsPerPageChange}
                                handlePageOffsetChange={handlePageOffsetChange}
                                offset={state.offset}
                                rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 75, 100, 150, 200, 250, 300]}
                              />
                            </div>
                          </TabPane>
                        )}
                        {/*-----------------------------------------------Student Enroll Details------------------------------------------------- */}
                        {activeTab === "Student Enroll Details" && (
                          <TabPane className="tab-pane fade show active" id="manage-3" ariaLabelledby="manage-tab-3">
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Student ID</TableCell>
                                  <TableCell>Student Name</TableCell>
                                  <TableCell>All</TableCell>
                                  <TableCell>Not Started</TableCell>
                                  <TableCell>Started</TableCell>
                                  <TableCell>Completed</TableCell>
                                  <TableCell>View Papers</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {isTableDataLoading ? (
                                  <TableRow>
                                    <TableCell colSpan={6} align="center">
                                      <ReactSpinner animation="border" />
                                    </TableCell>
                                  </TableRow>
                                ) : filteredPapers.length > 0 ? (
                                  filteredPapers.map((pep) => (
                                    <TableRow key={pep.student_id ?? pep.user_code}>
                                      <TableCell>{pep.user_code ?? pep.stu_id}</TableCell>
                                      <TableCell>{`${pep.first_name ?? ""} ${pep.last_name ?? ""}`.trim()}</TableCell>
                                      <TableCell>{(pep.assigned_count || 0) + (pep.finished_count || 0) + (pep.onprogress_count || 0)}</TableCell>
                                      <TableCell>{pep.assigned_count ?? 0}</TableCell>
                                      <TableCell>{pep.onprogress_count ?? 0}</TableCell>
                                      <TableCell>{pep.finished_count ?? 0}</TableCell>
                                      <TableCell>
                                        <Button
                                          className="btn btn-icon action-btn  btn-sm m-1 view-assement-btn flaticon-eye-icon"
                                          title="View Details"
                                          onClick={() => viewStudentAssessmentDetail(pep.student_id)}
                                        />
                                      </TableCell>
                                    </TableRow>
                                  ))
                                ) : (
                                  <TableRow>
                                    <TableCell colSpan={6} align="center">
                                      No data found
                                    </TableCell>
                                  </TableRow>
                                )}
                              </TableBody>
                            </Table>

                            <div className="d-flex justify-content-end mt-3">
                              <MaterialCustomTablePagination
                                totalCount={paperEnrolStatusCounts.totalPaperCount}
                                currentPage={state.currentPage}
                                limit={state.rowsPerPage}
                                handlePageChange={handlePageChange}
                                handleRowsPerPageChange={handleRowsPerPageChange}
                                handlePageOffsetChange={handlePageOffsetChange}
                                offset={state.offset}
                                rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 75, 100, 150, 200, 250, 300]}
                              />
                            </div>
                          </TabPane>
                        )}
                        {/*-----------------------------------------------Paper Enroll Details------------------------------------------------- */}
                        {activeTab === "Paper Enroll Details" && (
                          <TabPane className="tab-pane fade show active" id="manage-4" ariaLabelledby="manage-tab-4">
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Assessment ID</TableCell>
                                  <TableCell>Assessment Name</TableCell>
                                  <TableCell>No Of Students</TableCell>
                                  <TableCell>View Students</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {isTableDataLoading ? (
                                  <TableRow>
                                    <TableCell colSpan={4} align="center">
                                      <ReactSpinner animation="border" /> 
                                    </TableCell>
                                  </TableRow>
                                ) : filteredStudentEnrolments.length > 0 ? (
                                  filteredStudentEnrolments.map((assessment) => (
                                    <TableRow key={assessment.assessment_id}>
                                      <TableCell>{"ASMNT"}{assessment.assessment_id}</TableCell>
                                      <TableCell>{assessment.assess_name}</TableCell>
                                      <TableCell>{assessment.student_count}</TableCell>
                                      <TableCell>
                                        <Button
                                          className="btn btn-icon action-btn btn-sm m-1 view-assement-btn flaticon-eye-icon"
                                          title="View Students"
                                          onClick={() => {
                                            viewAssessmentStudentDetail(assessment.assessment_id);
                                          }}
                                        />
                                      </TableCell>
                                    </TableRow>
                                  ))
                                ) : (
                                  <TableRow>
                                    <TableCell colSpan={4} align="center">
                                      No data found
                                    </TableCell>
                                  </TableRow>
                                )}
                              </TableBody>
                            </Table>

                            <div className="d-flex justify-content-end mt-3">
                              <MaterialCustomTablePagination
                                totalCount={studentPaperEnrolment.totalAssessmentCount}
                                currentPage={state.currentPage}
                                limit={state.rowsPerPage}
                                handlePageChange={handlePageChange}
                                handleRowsPerPageChange={handleRowsPerPageChange}
                                handlePageOffsetChange={handlePageOffsetChange}
                                offset={state.offset}
                                rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 75, 100, 150, 200, 250, 300]}
                              />
                            </div>
                          </TabPane>
                        )}
                      </TabContent>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </CardBody>
        </Card>

        {/* this open if [assessmentModalShow=true] assesment details view in Student Enroll Details tab  */}
        {!modelDataLoding &&
        <Modal
          size="lg"
          centered
          show={assessmentModalShow}////////////////////////////////////
          onHide={() => setAssessmentModelShow(false)}
          backdrop="static"   // prevent closing by clicking outside
          keyboard={false}    // prevent closing by pressing ESC
        >
          <Modal.Header closeButton>
            <Modal.Title>Enrolled Assessment</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <UserOwnPaper /> {/*cll function*/}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setAssessmentModelShow(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        }
        
        {/* this open if [open=true] assesment details view in Student Enroll Details tab  */}
        {!modelDataLoding &&
        <Modal
          size="lg"
          centered
          show={studentModelShow}////////////////////////////////////
          onHide={() => setStudentModelShow(false)}
          backdrop="static"   // prevent closing by clicking outside
          keyboard={false}    // prevent closing by pressing ESC
        >
          <Modal.Header closeButton>
            <Modal.Title>Enrolled Students</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            < AssessmentOwnStudents/> {/*cll function*/}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setStudentModelShow(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        }

      </ContentWrapper>
    </div>
  );
}

export default UserReports;
